import { v4 as uuidv4, validate as validateUUID } from 'uuid';

/**
 * Valide si un ID est un UUID valide ou non vide
 * @param id - L'ID à valider
 * @returns true si l'ID est valide (UUID valide ou chaîne non vide)
 */
export function isValidId(id: string): boolean {
  if (!id || id.trim() === '') {
    return false;
  }
  // Si c'est un UUID valide, retourner true
  if (validateUUID(id)) {
    return true;
  }
  // Sinon, accepter toute chaîne non vide (pour compatibilité avec IDs temporaires)
  return id.trim().length > 0;
}

/**
 * Génère un UUID temporaire pour les nouveaux enregistrements
 * @returns Un UUID v4
 */
export function generateTemporaryId(): string {
  return uuidv4();
}

/**
 * Vérifie si un ID est un ID temporaire (nouvel enregistrement non sauvegardé)
 * Les IDs temporaires sont des UUID générés localement avant la sauvegarde
 * @param id - L'ID à vérifier
 * @returns true si l'ID semble être temporaire (optionnel, pour usage futur)
 */
export function isTemporaryId(id: string): boolean {
  // Pour l'instant, tous les UUID sont traités de la même manière
  // Cette fonction peut être étendue si nécessaire pour détecter des patterns spécifiques
  return isValidId(id);
}
